import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import MainPage from './components/MainPage/MainPage'
import SimplePagePreview from './components/SimplePagePreview/SimplePagePreview';
import PageWithSupagesPreview from './components/PageWithSupagesPreview/PageWithSupagesPreview';
import SubPagePreview from './components/SubPagePreview/SubPagePreview';
import LoadingPage from './components/LoadingPage/LoadingPage';

function RouterWrapper(props: {pages: any, subpages: any, website_language: string}) {

    const pages = props.pages;

    const subPages = props.subpages;

    const website_language = props.website_language;

    const location = useLocation();

    const links = new Array<any>;

    const subPagesLinks = new Array<any>;

    const [pagesLinks, setPagesLinks] = useState<Array<any>>();

    const [subPagesLinksForRoute, setSubPagesLinksForRoute] = useState<Array<any>>();

    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
    }, [])
  
    useEffect(() => {
    //   data && console.log(data);
        pages && setLoading(false);
        console.log(pages)
        if(pages) {
            pages.filter((page: any) => page.pageLanguage === "EN").map((page:any) => {
                if(page.pageLink !== null )
                {
                    links.push(page.pageLink)
                    if(page.subPages.length > 0) {
                        page.subPages.map((subPage: any) => {
                            subPagesLinks.push(subPage.subPageLink)
                        })
                    }
                }
            })
        }
        console.log(links);
        console.log(subPagesLinks)
        setPagesLinks(links);
        setSubPagesLinksForRoute(subPagesLinks);
    //   links.length > 0 && console.log(links)
    }, [pages])

    return (
        <Routes>
            <Route path="" element={<MainPage data={pages} />}>
            {
                (pagesLinks && pagesLinks!.length > 0) && pagesLinks!.map((pageLink: string, index: number) => (
                    // <Route path={index === 0 ? '/' : pageLink} element={<>{pageLink}</>} />
                    <>
                        {
                            pages && pages.filter((page: any) => {
                                if(page.pageLink === pageLink && page.pageLanguage === website_language) {
                                    return true
                                }
                                else {
                                    return false
                                }
                            })[0].subPages.length < 1 && 
                            <Route path={index === 0 ? '/' : pageLink} element={<SimplePagePreview page={pages.filter((page: any) => {
                                if(page.pageLink === pageLink && page.pageLanguage === website_language) {
                                    return true
                                }
                                else {
                                    return false
                                }
                            })[0]} />} />
                        }
                        {
                            pages && pages.filter((page: any) => {
                                if(page.pageLink === pageLink && page.pageLanguage === website_language) {
                                    return true
                                }
                                else {
                                    return false
                                }
                            })[0].subPages.length > 0 && 
                            <Route path={index === 0 ? '/' : pageLink} element={<PageWithSupagesPreview page={pages.filter((page: any) => {
                                    if(page.pageLink === pageLink && page.pageLanguage === website_language) {
                                        return true
                                    }
                                    else {
                                        return false
                                    }
                            })[0]} />}>
                            </Route>
                        }
                        {
                            subPages && (subPagesLinksForRoute && subPagesLinksForRoute!.length > 0) && subPagesLinksForRoute!.map((subpageLink: string, index: number) => (
                                <Route path={subpageLink} element={<SubPagePreview subPage={
                                    subPages.filter((subpage: any) => {
                                            if(subpage.subPageLink === subpageLink && subpage.subpageLanguage === website_language) {
                                                return true
                                            }
                                            else {
                                                return false
                                            }
                                        })[0]} 
                                    />} 
                                />
                            ))
                        }
                    </>
                ))
            }
            
            <Route path='*' element={<LoadingPage loading={loading} initialLink={location.pathname} />} />
            </Route>
        </Routes>
  )
}

export default RouterWrapper